module.exports = __webpack_public_path__ + "media/images/icon_industry-f079bc501bd407ca507d9c900b0ca5a2.png";